import { render, staticRenderFns } from "./CxLogs.vue?vue&type=template&id=6c0b31e1&scoped=true"
import script from "./CxLogs.vue?vue&type=script&lang=js"
export * from "./CxLogs.vue?vue&type=script&lang=js"
import style0 from "./CxLogs.vue?vue&type=style&index=0&id=6c0b31e1&prod&scoped=true&lang=css"
import style1 from "./CxLogs.vue?vue&type=style&index=1&id=6c0b31e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0b31e1",
  null
  
)

export default component.exports